import {createContext, useContext, useMemo, useState} from 'react'
import {filterItems} from '~/hooks/use_search'

const SearchContext = createContext({})
const {Provider} = SearchContext

export const SearchProvider = ({items, options, children}) => {
	const [search, setSearch] = useState('')

	const filteredItems = useMemo(() => filterItems(items, search, options), [items, search])

	const handleSearch = e => setSearch(e.target.value)
	const handleClear = () => setSearch('')

	const value = {
		search,
		filteredItems,
		handleSearch,
		handleClear,
		enabled: options.showSearch,
	}

	return <Provider value={value}>{children}</Provider>
}

export const useSearchContext = () => useContext(SearchContext)
